import {FC} from 'react';

import Button from '@/shared/components/button';
import {localize} from '@/shared/services/i18n';

import RegisterStepsCard from '../RegisterStepsCard';
import {LOGIN_STEPS_CARD} from './consts';

interface StepsSectionProps {
  handleSignInWithEmail: () => void;
}

const StepsSection: FC<StepsSectionProps> = ({handleSignInWithEmail}) => {
  return (
    <section className="flex flex-col items-center gap-8 bg-white px-4 py-14 text-center sm:gap-14 sm:px-12 sm:py-20">
      <div className="flex flex-col gap-4 px-4">
        <h3 className="font-bold text-2xl sm:text-3xl">
          {localize('landing_steps_how_works_title')}
        </h3>
        <p className="font-semibold text-base sm:text-xl">
          {localize('landing_steps_start_three_description')}
        </p>
      </div>
      <div className="flex w-full flex-col items-center justify-around gap-8 sm:flex-row sm:items-start">
        {LOGIN_STEPS_CARD.map((card) => (
          <RegisterStepsCard
            key={card.titleKey}
            image={card.image}
            title={localize(card.titleKey)}
            description={localize(card.descriptionKey)}
          />
        ))}
      </div>
      <Button
        onClick={handleSignInWithEmail}
        variant="primary"
        size="fit"
        className="w-full max-w-96"
      >
        {localize('landing_try_now_label')}
      </Button>
    </section>
  );
};

export default StepsSection;
